import {
  ADD_TO_COMPARISON,
  IAddToComparison,
  ISetComparisonNotification,
  SET_COMPARISON_NOTIFICATION,
} from '../../constants/actionTypes/offersComparison';
import { IAddOfferToComparisonResponse } from '../../repositories/offers-comparison/entities/add_offer_to_comparison/AddOfferToComparisonResponse';
import { addOfferToComparisonRequest } from '../../services/offersComparison';
import { EComparisonNotificationCategory } from '../../types/offersComparion';
import { TThunkAction } from '../../types/redux';

interface IAddOfferToComparisonParameters {
  entityId: number;
}

export function addOfferToComparison({ entityId }: IAddOfferToComparisonParameters): TThunkAction {
  return async (dispatch, getState, context) => {
    const { httpApi } = context;

    const response = await addOfferToComparisonRequest({ httpApi, parameters: { offerId: entityId } });

    if (response) {
      const { success, text, comparisonUrl, offerId } = response as unknown as IAddOfferToComparisonResponse;

      if (success) {
        dispatch<IAddToComparison>({
          type: ADD_TO_COMPARISON,
          offerId,
        });
      }

      dispatch<ISetComparisonNotification>({
        type: SET_COMPARISON_NOTIFICATION,
        text,
        url: comparisonUrl,
        category: success ? EComparisonNotificationCategory.Add : EComparisonNotificationCategory.Limit,
        offerId,
      });
    }
  };
}
